import React, { Component } from 'react';
import { map, findKey, filter } from 'lodash';
import JobSliderView from '../JobSliderView/JobSliderView';
import moment from 'moment';
import { imageBasePath, appBasePath } from '../../constants/staticData';

export default class JobHistoryList extends Component {

  render() {
    let {
      jobHistory,
      selectedJobState,
      onCardClick,
      vat
    } = this.props;
    let filteredJobHistory = [];
    switch (selectedJobState) {
      case 'All': {
        filteredJobHistory = jobHistory;
        break;
      }
      case 'Completed': {
        filteredJobHistory = filter(jobHistory, (job) => { return job.jobStatus == 'Completed' });
        break;
      }
      case 'Decline': {
        filteredJobHistory = filter(jobHistory, (job) => { return job.jobStatus == 'Decline' });
        break;
      }
      case 'Expired': {
        filteredJobHistory = filter(jobHistory, (job) => { return job.jobStatus == 'Expired' });
        break;
      }
      case 'Closed': {
        filteredJobHistory = filter(jobHistory, (job) => { return job.jobStatus == 'Completed' });
        break;
      }
    }
    const JobHistoryView = map(filteredJobHistory, (job, key) => {
      let createdAt = '-';
      if (job.createdAt) {
        createdAt = moment(job.createdAt);
        createdAt = createdAt.format('MMM DD, YYYY');
      }


      let totalAmount = 0;
      let subTotalAmount = 0;
      let vatAmount = 0;


      if(job.garagejobquote){
        job.paymentStatus = job.paymentstatus;
        job.requestId = job.requestid;
        subTotalAmount = job.garagejobquote.discountAmount? job.garagejobquote.totalamount - job.garagejobquote.discountAmount: job.totalamount;
        vatAmount =  subTotalAmount ? Number(subTotalAmount) *( Number(vat)/100): 0;
        totalAmount = subTotalAmount? Number(subTotalAmount)+Number(vatAmount) : 0;
      }else{
        subTotalAmount = job.discountAmount? job.totalamount - job.discountAmount: job.totalamount;
        vatAmount =  subTotalAmount ? Number(subTotalAmount) *( Number(vat)/100): 0;
        totalAmount = subTotalAmount? Number(subTotalAmount)+Number(vatAmount) : 0;
      }


      return (
        <div key={key}>
          <div className={"result-card status-card mhide " + job.serviceType.toLowerCase()} onClick={() => { onCardClick(job.userbookingrequestId, filteredJobHistory, job.jobStatus) }}>
            <ul className="list-unstyled">
              <li className="age-data">
                <div className="result-card-title">
                  <label>{createdAt}</label>
                </div>
                {/* <div className="result-card-status-icon">
                  <i className="mdi mdi-timer-sand" />
                </div> */}
              </li>
              <li className={job.jobStatus.toLowerCase() + " status"}>

                <label> {job.jobStatus} </label>
                <span> {createdAt} </span>

              </li>


              <li className="quote"> {totalAmount ? Number(totalAmount).toFixed(2) +  ' AED' : 'FREE'}</li>
              <li className="detail">
                <label>{job.requestId} {job.carmake + '' + job.carmodel} </label>
                <span> {job.details} </span>
              </li>
              <li className="payment-status" style={{ whiteSpace: 'nowrap', overflow: 'hidden', 'textOverflow': 'ellipsis', width: '120px' }}>

                <label> {job.paymentStatus ? job.paymentStatus.name == "Pending" || job.paymentStatus.name == "Failed" || job.paymentStatus.name == "Declined" || job.paymentStatus.name == "Cancelled" ? "UnPaid" :  job.paymentStatus.name : ""}</label>
                <span>
                      {job.paymentStatus && job.paymentStatus.method}
                </span>

              </li>
            </ul>
          </div>
          <div className={"result-card status-card mshow " + job.serviceType} onClick={() => { this.props.router.push(`${appBasePath}/job/${job.userbookingrequestId}`); }}>
            <ul className="list-unstyled">
              <li className="age-data">
                <label>REQUEST DATE</label>
                <span>
                  <div className="result-card-title">
                    <label>{createdAt}</label>
                  </div>
                </span>
                {/* <div className="result-card-status-icon">
                  <i className="mdi mdi-timer-sand" />
                </div> */}
              </li>
              <li className={job.jobStatus.toLowerCase() + " status"}>
                <label>STATUS</label>
                <span>
                  {job.jobStatus}
                </span>
              </li>
              <li className="quote">
                <label>QUOTE</label>
                <span>
                  {`${job.totalamount} ${job.currency}`}
                </span>
              </li>
              <li className="detail">
                <label>MODEL / DETAILS</label>
                <span className="quote-holder">
                  <label> {job.carmake + '' + job.carmodel} </label>
                  <span> {job.details} </span>
                </span>
              </li>
              <li className="payment-status">
                <label>PAYMENT MODE</label>
                <span className="quote-holder">
                   <label> {job.paymentStatus && job.paymentStatus.displayname ?job.paymentStatus.displayname : ""}</label>
                  <span className="payment-method">
                        {job.paymentStatus && job.paymentStatus.method}
                  </span>
                </span>

              </li>
            </ul>
          </div>
        </div>
      );
    })
    return (
      <div className="content-view ">
        {
          (filteredJobHistory && filteredJobHistory.length > 0)
            ?
            <div className="waiting-wrapper">
              <div className="result-category">
                <div className="status-heading mhide">
                  <ul className="list-unstyled">
                    <li className="request-date">
                      Request Date
                    </li>
                    <li className="status">
                      STATUS
                    </li>
                    <li className="quote">
                      QUOTE
                    </li>
                    <li className="model">
                      MODEL / DETAILS
                    </li>
                    <li className="area">
                      PAYMENT MODE
                    </li>
                  </ul>
                </div>
              </div>
              {JobHistoryView}
            </div>
            :
            <div className="empty-state-holder">
              <span className="empty-state-content">
                <img src={`${imageBasePath}/request_empty.png`} />
                <span>Oops! Looks like you don’t have any {selectedJobState} Jobs. </span>
              </span>
            </div>
        }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/JobHistory/JobHistoryList.jsx